import {
  appendTestSessionId,
  getBackendBaseUrl,
  persistTestConfig,
  persistTestSessionId,
  updateGlobalTestConfig,
} from "./config";

export type BackendMode = "dev" | "prod";

export function getBackendMode(): BackendMode {
  try {
    const q = new URL(window.location.href).searchParams.get("backend");
    if (q === "dev" || q === "prod") return q;
  } catch {}
  try {
    const saved = localStorage.getItem("ww/spa/backendMode");
    if (saved === "dev" || saved === "prod") return saved as BackendMode;
  } catch {}
  return "prod";
}

export function getWidgetOrigins(mode: BackendMode): { initUrl: string; chatBase: string } {
  const PROD = getBackendBaseUrl();
  const DEV = "https://wandway-back.onrender.com";
  const origin = (mode === "prod" ? PROD : DEV).replace(/\/$/, "");
  return {
    initUrl: `${origin}/widget/init`,
    chatBase: `${origin}/chat`,
  };
}

export async function fetchWidgetInit(
  storeId: string,
  mode: BackendMode
): Promise<{ token: string; apiBase: string } | null> {
  try {
    const { initUrl, chatBase } = getWidgetOrigins(mode);
    const url = `${initUrl}?store_id=${encodeURIComponent(storeId)}`;
    const urlWithSession = appendTestSessionId(url);
    const res = await fetch(urlWithSession, {
      method: "GET",
      credentials: "omit",
      cache: "no-store",
      mode: "cors",
    });
    if (!res.ok) return null;
    const data = await res.json();
    persistTestSessionId(data.test_session_id);
    persistTestConfig(data.test_config);
    updateGlobalTestConfig({ testSessionId: data.test_session_id, testConfig: data.test_config });
    const base = (data.api_base || "").replace(/\/$/, "");
    const secureBase = base.replace(/^http:\/\//i, "https://");
    const fixedApiBase = /\/chat$/.test(secureBase) ? secureBase : `${secureBase}/chat`;
    const nextToken = data.token as string | undefined;
    if (!nextToken) return null;
    const nextBase = mode === "prod" ? fixedApiBase : chatBase;
    return { token: nextToken, apiBase: nextBase };
  } catch {
    return null;
  }
}
